// ProfileCard.jsx
import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import profilePhoto from "../../../assets/redeem-card-icon.png";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import OrderDetailsModal from "../modals/OrderDetailsModal";

const HomeRedeemCard = ({ userProfile }) => {
  const navigate = useNavigate();
  const [orderNumber, setOrderNumber] = useState("");
  const [showModal, setShowModal] = useState(false);
  return (
    <Card className="dod-dash-main-page-profile-card d-flex flex-column align-items-center justify-content-around">
      <img src={profilePhoto} alt="Redeem Icon" class="dash-redeem-card-icon" />
      <div className="d-flex flex-column align-items-center">
        <h2 class="dash-redeem-card-title">Redeem Order</h2>
        <p class="dash-redeem-card-desc">Enter your order number to redeem</p>
      </div>
      <input
        type="text"
        value={orderNumber}
        onChange={(e) => setOrderNumber(e.target.value)}
        placeholder="Order number"
        class="dash-redeem-card-input"
      />
      <button
        onClick={() => {
          if (orderNumber.length > 1) {
            setShowModal(true);
          }
        }}
        class="dash-redeem-card-button"
      >
        Redeem Order
      </button>

      <OrderDetailsModal
        orderNumber={orderNumber}
        show={showModal}
        handleClose={() => setShowModal(false)}
        setOrderNumber={setOrderNumber}
      />
    </Card>
  );
};

export default HomeRedeemCard;
